
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSyncGoogle as ObiSyncGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sync-google.js';
 
 
 

 
 export const ObiSyncGoogle = createComponent({
   react: React,
   tagName: 'obi-sync-google',
   elementClass: ObiSyncGoogleElement,
   events: {
     
   }
  });
 
 